import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import UserTable from "../../components/Users/UserTable";
import Actions from "../../common/Actions/Actions";
import CreateUserModal from "./../../components/Users/CreateUserModal";
import ReassignmentModal from "../../components/Users/ReassignmentModal";

import { toast } from "react-toastify";
import get from "lodash/get";
import ConfirmationModal from "../../components/ServiceRequests/Facilitator/ConfirmationModal";
import { orderBy, set, sortBy } from "lodash";
import Spinner from "../../common/Spinner/Spinner";
import { getUser } from "../../utils/localStorage";

export default function UserListContainer(props) {
	const [selectedFacilitator, setSelectedFacilitator] = useState();
	const [
		facilitatorListExcludingSelectedUser,
		setFacilitatorListExcludingSelectedUser,
	] = useState([]);
	const [facilitatorList, setFacilitatorList] = useState([]);
	const [showReassignmentModal, setShowReassignmentModal] = useState(false);
	const [relatedServices, setRelatedServices] = useState([]);
	const [showCreateUserModal, setCreateUserModalVisibility] = useState(false);
	const [users, setUsers] = useState([]);
	const [activeUsers, setActiveUsers] = useState([]);
	const [roleOptions, setRoleOptions] = useState([]);
	const [userModalData, setUserModalData] = useState({});
	const [isEditUserModal, setEditUserModal] = useState(false);
	const [roleUpdatedOnce, setRoleUpdatedOnce] = useState(true);
	const [isLoading, setLoading] = useState(false);
	const [isLoadingServices, setIsLoadingServices] = useState(false);
	const [showConfirmationModal, setShowConfnirmationModal] = useState(false);
	const [roles, setRoles] = useState({})
	const [fromDate, setfromDate] = useState();
	const [toDate, settoDate] = useState();
	const [serviceType, setServiceType] = useState("old");
	const [facilitatorListForNewService, setFacilitatorListForNewService] = useState([]);
	const [selectedUser, setSelectedUser] = useState('')
	const [selected_assign_facilitator, setSelected_assign_facilitator] = useState()
	const [newFromDate, setNewFromDate] = useState();
	const [newToDate, setNewToDate] = useState();
	const [serviceAssignAlgo, setServiceAssignAlgo] = useState([
		{ label: "Choose Facilitator", value: "Choose Facilitator" },
		{ label: "Round Robin", value: "Round Robin" },
	])
	const [selectedAlgo, setSelectedAlgo] = useState({ label: "Choose Facilitator", value: "Choose Facilitator" });
	const [viewServices, setViewServices] = useState(false);

	/**
	 * INIT START
	 */
	useEffect(() => {
		setLoading(true);
		api.getAllFacilitators().then(({ data }) => {
			const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			setFacilitatorList(f);
		});
		api.getFacilitatorList().then(({ data }) => {
			const list = data?.data?.map((e) => ({
				value: e.id,
				email: e.email,
				label: `${e.first_name} ${e.last_name !== null ? e.last_name : ''}`,
			}));
			setFacilitatorListForNewService(list);
			// const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			// setFacilitatorList(f);
		});
		getUsers();
		api.getUserRoles().then(({ data }) => {
			const roleOptions = Object.entries(data).map(([key, value]) => {
				return {
					value: parseInt(key),
					label: value,
				};
			});
			setRoles(data);
			setRoleOptions(roleOptions);
		});
		setLoading(false);
	}, []);
	/**
	 * INIT END
	 */
	useEffect(() => {
		if (!showCreateUserModal) {
			setEditUserModal(false);
			setUserModalData({});
			// setRoleUpdatedOnce(true);
		}
	}, [showCreateUserModal]);

	const dateAdjusted = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					// toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
					toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
				)
			);
		}
		return toDateAdjusted;
	}

	const dateAdjusted1 = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					// toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
					toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
				)
			);
		}
		return toDateAdjusted;
	}

	const getUsers = () => {
		api.getUsers().then(({ data }) => {
			// const {results} = data;
			const myData = data
				.sort((a, b) => b.is_active.toString().localeCompare(a.is_active.toString()));

			setUsers(myData);

			let temp = data
				.filter(
					(e) => e.is_active === true && e.out_of_office === false
				)
				.map((e) => e.email);
			setActiveUsers(temp);

		});
	};

	const onSelectFacilitator = (e) => {
		setSelectedFacilitator(e);
	};

	const onSelectNewFacilitator = (e) => {
		setSelected_assign_facilitator(e);
	};

	const onSelectAlgorithm = (e) => {
		setSelectedAlgo(e)
	}

	const onDeactivateAndReassign = async () => {
		setLoading(true);
		try {
			const { email } = userModalData;

			// eslint-disable-next-line
			const data = await api
				.deactivateUser(email)
				.then((d) => {
					toast("User deactivated successfully", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				})
				.catch((error) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			try {
				if (relatedServices.length > 0) {
					let nUserIds = relatedServices.map((e) => e.nUserId);
					const data1 = await api
						.assignFacilitator({
							Facilitator: selectedFacilitator.value,
							user_ids: nUserIds,
						})
						.then((d) => {
							toast("Services reassigned successfully", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						})
						.catch((error) => {
							toast(
								"Something went wrong. Contact webadmin support.",
								{
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								}
							);
						});
				}
			} catch (error) {
				console.log(error);
			}
			toggleReassignmentModal();
			setSelectedFacilitator(null);
			getUsers();
			toggleModal();
			setEditUserModal(false);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};
	const handleOutOfOfficeAndReassign = async () => {

		
		try {
			if(serviceType == "old"){
				if (!fromDate) {
			toast("From date is required", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if (!toDate) {
			toast("To date is required", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		setIsLoadingServices(true);

			const { email } = userModalData;
			// eslint-disable-next-line
			const data = await api
				.deactivateUser(email, outOfOfficeOperation, dateAdjusted1(fromDate), dateAdjusted(toDate))
				.then((d) => {
					toast("Successfully marked out of office", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					getUsers();
				})
				.catch((error) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});

			if (relatedServices.length > 0 && selectedFacilitator) {
				let nUserIds = relatedServices.map((e) => e.nUserId);
				const data1 = await api
					.assignFacilitator({
						Facilitator: selectedFacilitator.value,
						user_ids: nUserIds,
					})
					.then((d) => {
						toast("Services reassigned successfully", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					})
					.catch((error) => {
						toast(
							"Something went wrong. Contact webadmin support.",
							{
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							}
						);
					});
			}

			toggleReassignmentModal();
			setoutOfOfficeOperation(!outOfOfficeOperation);

			setSelectedFacilitator(null);
			setfromDate("");
			settoDate("");
			getUsers();
			toggleModal();
			setEditUserModal(false);
			} else {

				if (!newFromDate) {
					toast("From date is required", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}

				if (!newToDate) {
					toast("To date is required", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}
				if (selectedAlgo.value !== "Round Robin" && !selected_assign_facilitator) {
					toast("please selected facilitator", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}
				setIsLoadingServices(true);

				const { email } = userModalData;
				// eslint-disable-next-line
				const data = await api
					.deactivateUser(email, outOfOfficeOperation, dateAdjusted1(newFromDate), dateAdjusted(newToDate))
					.then((d) => {
						toast("Successfully marked out of office", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
						const formattedToDate = new Date(newToDate).toISOString().split("T")[0];
						const formattedFromDate = new Date(newFromDate).toISOString().split("T")[0];
						if (selectedAlgo.value !== "Round Robin") {
							let payload = {
								facilitator: selectedUser,
								assign_facilitator: selected_assign_facilitator.value,
								start_date: formattedFromDate,
								end_date: formattedToDate,
								facilitator_email: userModalData.email,
								assign_facilitator_email:selected_assign_facilitator.email
							}

							const assignUser = api
								.saveFacilitator(payload)
								.then((d) => {
									// toast("Successfully marked out of office", {
									// 	autoClose: 5000,
									// 	type: toast.TYPE.SUCCESS,
									// });
									getUsers();
								})
								.catch((error) => {
									toast("Something went wrong. Contact webadmin support.", {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								});
						}else{
							getUsers();
						}
					})
					.catch((error) => {
						toast("Something went wrong. Contact webadmin support.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});


				if (relatedServices.length > 0 && selectedFacilitator) {
					let nUserIds = relatedServices.map((e) => e.nUserId);
					const data1 = await api
						.assignFacilitator({
							Facilitator: selectedFacilitator.value,
							user_ids: nUserIds,
						})
						.then((d) => {
							toast("Services reassigned successfully", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						})
						.catch((error) => {
							toast(
								"Something went wrong. Contact webadmin support.",
								{
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								}
							);
						});
				}

				toggleReassignmentModal();
				setoutOfOfficeOperation(!outOfOfficeOperation);

				setSelectedFacilitator(null);
				setfromDate("");
				setNewFromDate("")
				settoDate("");
				setNewToDate("")
				setSelected_assign_facilitator("")
				getUsers();
				toggleModal();
				setEditUserModal(false);
			}
		} catch (error) {
			//show error toast
		}
		setIsLoadingServices(false);
	};

	useEffect(() => {
		if (facilitatorList.length > 0) {
			let temp = facilitatorList;

			for (var i = 0; i < facilitatorList.length; i++) {
				if (temp[i].value === userModalData.email) {
					temp.splice(i, 1);
					break;
				}
			}
			temp = temp.filter((e) => activeUsers.includes(e.value) === true);
			setFacilitatorListExcludingSelectedUser(temp);
		}
	}, [userModalData]);

	const getRelatedServices = async (instance = false, flag = false) => {
		setIsLoadingServices(true);
		if (!userModalData.email) return;
		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = { F_email: userModalData.email };
			let sortParams = null;
			const pagination = false;
			const unassigned = null;
			const serviceRequestList = [];
			const followupInPast = null;
			const followupToday = null;
			const failedPayments = null;
			const statusList = [
				"Ready for Progression",
				"Service Delivery Started",
				"Service Deliverables Ready",
				"Full Payment Requested",
				"Full Payment Received",
			];
			const paymentStatus = [];
			const PackageList = [];
			const { data } = await api.getAllServicesSPM(
				page + 1,
				0,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination
			);
			// let { results, count } = data;
			// let results = data.map((e) => {
			// 	if (e["customer_meta"]["email"])
			// 		e["sEmailAddress"] = e["customer_meta"]["email"];
			// 	else e["sEmailAddress"] = "";
			// 	if (e["customer_meta"]["mobile_number"])
			// 		e["sContactNumber"] = e["customer_meta"]["mobile_number"];
			// 	else e["sContactNumber"] = "";
			// 	if (e["refCurrentState"]["sServiceState"])
			// 		e["refSRState"] = e["refCurrentState"]["sServiceState"];
			// 	else e["refSRState"] = "";
			// 	if (e["refFacilitator"])
			// 		e["refFacilitator"] = e["refFacilitator"]["email"];
			// 	else e["refFacilitator"] = "";
			// 	return e;
			// });
			// setRelatedServices(results)
			const results = data.map((e) => ({
				...e,
				sEmailAddress: e?.customer_meta?.email || e?.sEmailAddress ||"",
				sContactNumber: e?.customer_meta?.mobile_number || e?.sContactNumber || "",
				refSRState: e?.refCurrentState?.sServiceState || "",
				refFacilitator: e?.refFacilitator?.email || "",
				sServiceCode: e?.refServiceType?.sServiceCode || e?.sServiceCode || "",
			}));

			setRelatedServices(results);
		} catch (error) {
			console.error(error);
		}
		setIsLoadingServices(false);
	};
	// useEffect(() => {
	// 	getRelatedServices();
	// }, [userModalData]);

	const onViewServices =()=>{
		setViewServices(!viewServices)
		if(viewServices == false){
			getRelatedServices();
		}
	}

	const toggleConfirmationModal = () => {
		setShowConfnirmationModal(!showConfirmationModal);
	};

	const handleConfirmDelete = () => {
		const { role, email, first_name, last_name } = userModalData;
		const updatedRole = role.map((r) => r.value ?? r);
		const payload = {
			email,
			role: updatedRole,
			first_name,
			last_name,
			delete_user_record: true,
		};
		setLoading(true);
		api.createUser(payload)
			.then(() => {
				toast("User deleted successfully.", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				toggleModal();
				getUsers();
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				if (error && error.response) {
					//show error toast
					const existingUser = get(error, "response.data.email");
					const existingRole = get(error, "response.data.role");
					if (existingUser) {
						toast("Email: " + existingUser[0], {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					} else if (existingRole) {
						toast("Role: " + existingRole[0], {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					} else {
						toast(error.response.data.detail, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
				}
			});
		toggleConfirmationModal();
		toggleModal();
		getUsers();
		setLoading(false);
	};
	const handleSaveUser = () => {
		setLoading(true);
		let { role, email, first_name, last_name, facilitator_status = false } = userModalData;
		role = role ? role : [];
		const updatedRole = role.map((r) => r.value ?? r);
		const payload = {
			email,
			role: updatedRole,
			first_name,
			last_name,
			delete_user_record: false,
			facilitator_status
		};
		if (isEditUserModal) {
			api.updateUser(payload)
				.then(() => {
					toast("User saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					toggleModal();
					setEditUserModal(false);
					getUsers();
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					if (error && error.response) {
						//show error toast
						const existingUser = get(error, "response.data.email");
						const existingRole = get(error, "response.data.role");
						if (existingUser) {
							toast(existingUser[0], {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						} else if (existingRole) {
							toast(existingRole[0], {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						} else {
							toast(error.response.data.detail, {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						}
					}
				});
		} else {
			api.createUser(payload)
				.then(() => {
					toast("User saved successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					toggleModal();
					getUsers();
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					if (error && error.response) {
						//show error toast
						const existingUser = get(error, "response.data.email");
						const existingRole = get(error, "response.data.role");
						if (existingUser) {
							toast("Email: " + existingUser[0], {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						} else if (existingRole) {
							toast("Role: " + existingRole[0], {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						} else {
							// toast(error.response.data.detail, {
							//   autoClose: 5000,
							//   type: toast.TYPE.ERROR,
							// });
							toggleConfirmationModal();
						}
					}
				});
		}
	};
	const handleDeactivateUser = async () => {
		toggleReassignmentModal();
		setFlagForOutOfOfficeAndActivateUser("Activate");
	};

	const [flagForOutOfOfficeAndActivateUser, setFlagForOutOfOfficeAndActivateUser] = useState("");

	const [outOfOfficeOperation, setoutOfOfficeOperation] = useState(false);
	const onOutOfOffice = () => {
		setoutOfOfficeOperation(!outOfOfficeOperation);
		toggleReassignmentModal();
		setFlagForOutOfOfficeAndActivateUser("OutOfOffice");
	};
	const handleReactivateUser = async () => {
		setLoading(true);
		try {
			const { email } = userModalData;
			// eslint-disable-next-line
			const data = await api
				.reactivateUser(email)
				.then((d) => {
					toast("User reactivated successfully", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					getUsers();
				})
				.catch((error) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			getUsers();
			toggleModal();
			setEditUserModal(false);
		} catch (error) {
			//show error toast
		}
		setLoading(false);
	};
	const onInOffice = async () => {
		setLoading(true);
		try {
			const { email } = userModalData;
			// eslint-disable-next-line
			const data = await api
				.markInOffice(email)
				.then((d) => {
					toast("Successfully marked in office", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					getUsers();
				})
				.catch((error) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			getUsers();
			toggleModal();
			setEditUserModal(false);
			// setoutOfOfficeOperation(!outOfOfficeOperation);
		} catch (error) {
			//show error toast
		}
		setLoading(false);
	};

	const handleUserModalDataChange = (name, value, onlyChangeOnce = null) => {
		// console.log(name, ">>>>name handleUserModalDataChange");
		// console.log(value, ">>>>value handleUserModalDataChange");
		// console.log(onlyChangeOnce, ">>>>>onlyChangeOnce")

		// //old (failing to add user)
		// let alreadyRoleOfSelectedUser = userModalData.role;
		// console.log(alreadyRoleOfSelectedUser, ">>>>alreadyRoleOfSelectedUser");


		// let updatingRoles = value.map(obj => {
		// 	const {value, label}  = obj;
		// 	return value
		// })
		// console.log(updatingRoles, ">>>>>updatingRoles");


		// let prevAndChangingRoleDifferences = updatingRoles.find(val => !alreadyRoleOfSelectedUser.includes(val))
		// console.log(prevAndChangingRoleDifferences, ">>>>>prevAndChangingRoleDifferences");

		// let isReadyToUpdate = true;

		// if(prevAndChangingRoleDifferences == 18){
		// 	if(!updatingRoles.includes(15)){
		// 		isReadyToUpdate = false;

		// 		toast(`User must be a program manager admin`, {
		// 			autoClose: 5000,
		// 			type: toast.TYPE.SUCCESS,
		// 		})
		// 	}else if (alreadyRoleOfSelectedUser.includes(17)){
		// 		isReadyToUpdate = false;

		// 		toast(`User is already a maker`, {
		// 			autoClose: 5000,
		// 			type: toast.TYPE.SUCCESS,
		// 		})
		// 	}
		// }else if(prevAndChangingRoleDifferences == 17){
		// 	if(!updatingRoles.includes(15)){
		// 		isReadyToUpdate = false;

		// 		toast(`User must be a program manager admin`, {
		// 			autoClose: 5000,
		// 			type: toast.TYPE.SUCCESS,
		// 		})
		// 	}else if (alreadyRoleOfSelectedUser.includes(18)){
		// 		isReadyToUpdate = false;

		// 		toast(`User is already a checker`, {
		// 			autoClose: 5000,
		// 			type: toast.TYPE.SUCCESS,
		// 		})
		// 	}
		// }

		// console.log(isReadyToUpdate, ">>>>");

		// if(isReadyToUpdate){
		// 	if (onlyChangeOnce) {
		// 		setRoleUpdatedOnce(false);
		// 	}
		// 	const updated = { ...userModalData, [name]: updatingRoles };
		// 	setUserModalData(updated);
		// }


		// new(add user and condition for maker and checker when adding and edititng)
		// console.log(name, ">>>>name handleUserModalDataChange");
		// console.log(value, ">>>>value handleUserModalDataChange");
		// console.log(onlyChangeOnce, ">>>>>onlyChangeOnce")
		// console.log(userModalData, ">>>>userModalData");
		

		if (name == "role" && isEditUserModal == true) {
			let alreadyRoleOfSelectedUser = userModalData.role;

			let updatingRoles = value.map(obj => {
				const { value, label } = obj;
				return value
			})


			let prevAndChangingRoleDifferences = updatingRoles.find(val => !alreadyRoleOfSelectedUser.includes(val))

			let isReadyToUpdate = true;

			if (prevAndChangingRoleDifferences == 18) {
				if (!updatingRoles.includes(15)) {
					isReadyToUpdate = false;

					toast(`User must be a program manager admin`, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					})
				} else if (alreadyRoleOfSelectedUser.includes(17)) {
					isReadyToUpdate = false;

					toast(`User is already a maker`, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					})
				}
			} else if (prevAndChangingRoleDifferences == 17) {
				if (!updatingRoles.includes(15)) {
					isReadyToUpdate = false;

					toast(`User must be a program manager admin`, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					})
				} else if (alreadyRoleOfSelectedUser.includes(18)) {
					isReadyToUpdate = false;

					toast(`User is already a checker`, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					})
				}
			}


			if (isReadyToUpdate) {
				if (onlyChangeOnce) {
					setRoleUpdatedOnce(false);
				}
				const updated = { ...userModalData, [name]: updatingRoles };
				setUserModalData(updated);
			}
		} else {
			// (working on in adding user ading both maker and checker)
			if (onlyChangeOnce) {
				setRoleUpdatedOnce(false);
			}

			if (name == "role") {
				// console.log(`>>>>entered if of name == "role"`);
				
				let alreadyRoleOfSelectedUser = userModalData.role;
				let valsOfAlreadyRoleOfSelectedUser = alreadyRoleOfSelectedUser?.map((obj) => {
					const {value} = obj;
					return value
				})
				// console.log(alreadyRoleOfSelectedUser, ">>>>alreadyRoleOfSelectedUser");
				// console.log(valsOfAlreadyRoleOfSelectedUser, ">>>>valsOfAlreadyRoleOfSelectedUser");
				

				let updatingRoles = value.map(obj => {
					const { value, label } = obj;
					return value
				})
				// console.log(updatingRoles, ">>>>>updatingRoles");

				let prevAndChangingRoleDifferences = updatingRoles.find(val => !valsOfAlreadyRoleOfSelectedUser?.includes(val))
				// console.log(prevAndChangingRoleDifferences, ">>>>>prevAndChangingRoleDifferences");

				let isReadyToUpdate = true;

				if (prevAndChangingRoleDifferences == 18) {
					// console.log(">>>>entered if of prevAndChangingRoleDifferences == 18 ");
					
					if (!updatingRoles.includes(15)) {
						// console.log(">>>entered if of !updatingRoles.includes(15)");
						
						isReadyToUpdate = false;

						toast(`User must be a program manager admin`, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						})
					} else if (valsOfAlreadyRoleOfSelectedUser.includes(17)) {
						// console.log(">>>>entered if of valsOfAlreadyRoleOfSelectedUser.includes(17)");
						
						isReadyToUpdate = false;

						toast(`User is already a maker`, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						})
					}else{
						// console.log(">>>>Entered elseee");
						
						const updated = { ...userModalData, [name]: value };
						setUserModalData(updated);
					}
				} else if (prevAndChangingRoleDifferences == 17) {
					// console.log(">>>entered else if of prevAndChangingRoleDifferences == 17");
					
					if (!updatingRoles.includes(15)) {
						// console.log(">>>entered if of !updatingRoles.includes(15");
						
						isReadyToUpdate = false;

						toast(`User must be a program manager admin`, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						})
					} else if (valsOfAlreadyRoleOfSelectedUser.includes(18)) {
						// console.log(">>>>entered else if of valsOfAlreadyRoleOfSelectedUser.includes(18)");
						
						isReadyToUpdate = false;

						toast(`User is already a checker`, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						})
					}else{
						// console.log(">>>enteredd elseee");
						
						const updated = { ...userModalData, [name]: value };
						setUserModalData(updated);
					}
				}else{
					// console.log(">>>>entereddd elssseee");
					
					const updated = { ...userModalData, [name]: value };
						setUserModalData(updated);
				}

			}else{
				// console.log(">>>>>entereddd  most outer else");
				
				const updated = { ...userModalData, [name]: value };
				setUserModalData(updated);
			}
		}
	};

	// const handleUserModalDataChange = (name, value, onlyChangeOnce = null) => {
	// 	console.log(onlyChangeOnce, ">>>>onlyChangeOnce");

	// 	if (onlyChangeOnce) {
	// 		setRoleUpdatedOnce(false);
	// 	}
	// 	const updated = { ...userModalData, [name]: value };
	// 	setUserModalData(updated);
	// };

	const toggleReassignmentModal = () => {
		api.getFacilitatorList().then(({ data }) => {
			const list = data?.data?.map((e) => ({
				value: e.id,
				email: e.email,
				label: `${e.first_name} ${e.last_name !== null ? e.last_name : ''}`,
			}));
			setFacilitatorListForNewService(list);
			// const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			// setFacilitatorList(f);
		});
		setShowReassignmentModal(!showReassignmentModal);
		settoDate("");
		setfromDate("");
		setNewFromDate("")
		settoDate("");
		setNewToDate("")
		setSelected_assign_facilitator("")
		setViewServices(false);
	};
	const toggleModal = () => {
		if (showCreateUserModal && !userModalData) {
			setUserModalData({});
			// setEditUserModal(false);
		}
		if (selectedFacilitator !== undefined) setSelectedFacilitator(null);
		if (relatedServices.length !== 0) setRelatedServices([]);
		setRoleUpdatedOnce(true);
		setCreateUserModalVisibility(!showCreateUserModal);
	};
	return (
		<div className={`p-4 pb-4  ${isLoading && "set-opacity"}`}>
			{isLoading ? <Spinner className="center"></Spinner> : ""}
			<Actions onPrimaryActionClick={toggleModal} />
			<UserTable
				data={users}
				onUserRowClick={({ original }) => {
					setSelectedUser(original.id);
					setUserModalData(original);
					setEditUserModal(true);
					toggleModal();
				}}
				roles={roles}
			/>
			<CreateUserModal
				isOpen={showCreateUserModal}
				isEditUserModal={isEditUserModal}
				toggleModal={toggleModal}
				roleOptions={roleOptions}
				onSaveUser={handleSaveUser}
				userModalData={userModalData}
				onInputChange={handleUserModalDataChange}
				onDeactivateUser={handleDeactivateUser}
				onReactivateUser={handleReactivateUser}
				onOutOfOffice={onOutOfOffice}
				onInOffice={onInOffice}
				onlyChangeOnce={roleUpdatedOnce}
				isLoading={isLoading}
			/>
			<ReassignmentModal
				isLoadingServices={isLoadingServices}
				isOpen={showReassignmentModal}
				toggleModal={toggleReassignmentModal}
				userModalData={userModalData}
				relatedServices={relatedServices}
				facilitatorList={facilitatorListExcludingSelectedUser}
				selectedFacilitator={selectedFacilitator}
				outOfOfficeOperation={outOfOfficeOperation}
				onSelectHandholder={onSelectFacilitator}
				onAssignHandholder={onDeactivateAndReassign}
				handleDeactivateAndReassign={onDeactivateAndReassign}
				handleOutOfOfficeAndReassign={handleOutOfOfficeAndReassign}
				numberOfServices={relatedServices.length}
				flagForOutOfOfficeAndActivateUser={flagForOutOfOfficeAndActivateUser}
				fromDate={fromDate}
				toDate={toDate}
				setfromDate={setfromDate}
				settoDate={settoDate}
				serviceType={serviceType}
				setServiceType={setServiceType}
				selected_assign_facilitator={selected_assign_facilitator}
				setSelected_assign_facilitator={setSelected_assign_facilitator}
				facilitatorListForNewService={facilitatorListForNewService}
				onSelectNewFacilitator={onSelectNewFacilitator}
				onSelectAlgorithm={onSelectAlgorithm}
				setNewFromDate={setNewFromDate}
				newFromDate={newFromDate}
				setNewToDate={setNewToDate}
				newToDate={newToDate}
				selectedAlgo={selectedAlgo}
				serviceAssignAlgo={serviceAssignAlgo}
				onViewServices={onViewServices}
				viewServices={viewServices}
			></ReassignmentModal>
			<ConfirmationModal
				message="The user is created in WebAdmin. But there exists a user in WebApp with 'User' role with same email address. Do you wish to delete the user from WebApp?"
				isOpen={showConfirmationModal}
				toggleModal={toggleConfirmationModal}
				changeState={handleConfirmDelete}
				buttonText="Delete"
			/>
		</div>
	);
}
